  function handleMapButtonClick(event) {
      let clickedButton = event.target;
      let overlayId = clickedButton.dataset.overlayMapButton; 

      // Get all overlay elements
      let overlays = document.querySelectorAll('[data-map-overlay]');

      // Hide all overlays
      overlays.forEach(overlay => overlay.classList.add('hide'));

      // Show the clicked overlay (if an ID is provided)
      if (overlayId) {
          const overlayToShow = document.querySelector(`[data-map-overlay="${overlayId}"]`);
          if (overlayToShow) {
          overlayToShow.classList.remove('hide');
          }
      }
  }

// Event listeners for all buttons below the map
    const buttons = document.querySelectorAll('[data-overlay-map-button]'); 
    buttons.forEach(button => button.addEventListener('click', handleMapButtonClick));

const resetBtn = document.getElementById('reset');

resetBtn.addEventListener('click', () => {    
    let overlays = document.querySelectorAll('[data-map-overlay]');
    overlays.forEach(overlay => overlay.classList.remove('hide'));; // Reset all buttons to not clicked   
})

function closeModal(event) {
    let clickedButton = event.target;
    let targetDialog = clickedButton.dataset.closeModal;
    document.getElementById(targetDialog).close()
}

const closeModalButtons = document.querySelectorAll('[data-close-modal]');
closeModalButtons.forEach(button => button.addEventListener("click", closeModal));


const bflVideoArray = [
  "https://cdn.shopify.com/videos/c/o/v/aec5cab6b33149c5b12cef13c200a415.mp4", 
  "https://cdn.shopify.com/videos/c/o/v/0a24d3e439ec465189f579d93217e3e3.mp4",
  "https://cdn.shopify.com/videos/c/o/v/c27f37cb248d467f9ea83545ef3fdc36.mp4",
  "https://cdn.shopify.com/videos/c/o/v/3bfb05a0e2bc4f59862b98eec8f4825c.mp4",
  "https://cdn.shopify.com/videos/c/o/v/f324c37a00604807bee54e64d7d78329.mp4",
  "https://cdn.shopify.com/videos/c/o/v/182c1dc7f2c64747950148b478a18e76.mp4",
  "https://cdn.shopify.com/videos/c/o/v/e11a1dd92a694ff3995b8b8e07c0c91f.mp4"]

const erVideoArray = [
  "https://cdn.shopify.com/videos/c/o/v/18d69977832e496dbec954323ea29418.mp4",
  "https://cdn.shopify.com/videos/c/o/v/4e279ea6e8de4abfa84132a03ea36508.mp4",
  "https://cdn.shopify.com/videos/c/o/v/7b623240a98e444ba49565ba8fd04aac.mp4",
  "https://cdn.shopify.com/videos/c/o/v/2a5953eed0fb4cbfb255169eceb72b43.mp4",
  "https://cdn.shopify.com/videos/c/o/v/4143bab2f5504492b047fbbd4dabd79a.mp4",
  "https://cdn.shopify.com/videos/c/o/v/c0916cbd4ef443dcb1227c5264cbb447.mp4",
  "https://cdn.shopify.com/videos/c/o/v/2c652beda8af4affaaef91062101bd8e.mp4",
  "https://cdn.shopify.com/videos/c/o/v/90f3890e98b94b73b7b6568f1e61aaa1.mp4",
  "https://cdn.shopify.com/videos/c/o/v/ea19ca4c417a4481903fba364a2848f0.mp4",
  "https://cdn.shopify.com/videos/c/o/v/c7ebf89e346c4ab38e748a4ddf986776.mp4",
  "https://cdn.shopify.com/videos/c/o/v/686b4e38d8f74057b618009e6127c426.mp4",
  "https://cdn.shopify.com/videos/c/o/v/df571288d8e24c7b8126a63d563fc455.mp4",
  "https://cdn.shopify.com/videos/c/o/v/07c79d9954074c1c91659a2b8286489c.mp4"
]


// function to open modal and randomly select a video from arrays above from using clickedButton.id

function openModal(event) {
    let clickedButton = event.target;
    let openedModal = document.getElementById(clickedButton.id+'_modal');         
    let modalVideo = document.querySelector(`.${clickedButton.id}-modal-video`)
    openedModal.showModal() 
    if (clickedButton.id == 'bfl'){
    modalVideo.src = bflVideoArray[Math.floor(Math.random() * bflVideoArray.length)]}
    if (clickedButton.id == 'er'){
    modalVideo.src = erVideoArray[Math.floor(Math.random() * erVideoArray.length)]}
  
}

let overlayMaps = document.querySelectorAll('[data-map-overlay]');
overlayMaps.forEach(mapOverlay => mapOverlay.addEventListener("click", openModal));

    




  



